import api from './api';

/** Categories are fixed for now (seeded per firm); the server only lists them. */
const CategoryService = {
    list: () => api.get('/categories').then(r => r.data),
};

export default CategoryService;
